import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppProvider from "./store/providers/AppProvider";
import AdminProvider from "./store/providers/AdminProvider";
import SnackbarProviderWrapper from "./store/providers/SnackbarProvider";
import { ThemeProvider } from "./store/contexts/ThemeContext";
import "./styles/index.scss";
import "./styles/global-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <SnackbarProviderWrapper>
      <AdminProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </AdminProvider>
    </SnackbarProviderWrapper>
  </ThemeProvider>
);
